import { render, staticRenderFns } from "./AppWelcome.vue?vue&type=template&id=52bac4c8&scoped=true&"
import script from "./AppWelcome.vue?vue&type=script&lang=js&"
export * from "./AppWelcome.vue?vue&type=script&lang=js&"
import style0 from "./AppWelcome.vue?vue&type=style&index=0&id=52bac4c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bac4c8",
  null
  
)

export default component.exports